import AdminHeader from "./AdminHeader";
import { useTypedDispatch, useTypedSelector } from "@lib/redux";
import {
  StyledAppLayout,
  StyledAppLayoutSplitter,
  StyledBodyPanel,
  StyledFooterPanel,
  StyledHeaderPanel,
} from "./index.styled";
import { updateFooter, updateWindowSize } from "@lib/redux/slices/screen";
import { useEffect, useState } from "react";
import AdminFooter from "./AdminFooter";
import AdminBody from "./AdminBody";
// import AdminFooterAppMenu from "./AdminFooterAppMenu";
import { AppLayoutProps } from "@lib/components/AppComponents/AppLayout/Layouts";

const AdminLayout: React.FC<AppLayoutProps> = ({
  children,
  routesConfig,
  menuProps,
}) => {
  const dispatch = useTypedDispatch();
  const {
    header,
    footer,
    // window: windowState,
  } = useTypedSelector((state) => state.screen);
  const [footerHeight, setFooterHeight] = useState<number | null>(null);

  useEffect(() => {
    setFooterHeight(footer.height);
  }, [footer.height]);

  const handleResize = (sizes: number[]) => {
    setFooterHeight(sizes[2]);
  };

  const handleResizeEnd = (sizes: number[]) => {
    dispatch(updateFooter({ height: sizes[2] }));
  };

  useEffect(() => {
    dispatch(updateWindowSize(window.innerWidth));
    const handleWindowResize = () => {
      dispatch(updateWindowSize(window.innerWidth));
    };
    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [dispatch]);

  return (
    <StyledAppLayout>
      {/* {windowState.width < windowState.breakpointHide && (
        <AdminFooterAppMenu routesConfig={routesConfig} />
      )} */}

      <StyledAppLayoutSplitter
        layout="vertical"
        onResize={handleResize}
        onResizeEnd={handleResizeEnd}
      >
        {/* {windowState.width >= windowState.breakpointHide && ( */}
        <StyledHeaderPanel size={header.height} resizable={false}>
          <AdminHeader routesConfig={routesConfig} />
        </StyledHeaderPanel>
        {/* )} */}

        <StyledBodyPanel>
          <AdminBody
            children={children}
            routesConfig={routesConfig}
            menuProps={menuProps}
          />
        </StyledBodyPanel>

        {footer.enabled && (
          <StyledFooterPanel
            size={footerHeight}
            defaultSize={footer.defaultHeight}
            min={footer.minHeight}
            max={footer.maxHeight}
          >
            <AdminFooter />
          </StyledFooterPanel>
        )}
      </StyledAppLayoutSplitter>
    </StyledAppLayout>
  );
};

export default AdminLayout;
